import React, { useState, useEffect } from "react";
import { format, isSameDay } from "date-fns";

function CurrentFiltersPills({
  background,
  isSmallScreen,
  fundingCategory,
  type,
  tabType,
  noticeType,
  activity_code,
  clinicalTrialsAllowedSelected,
  fundingInstrumentSelected,
  fundingOrganizations,
  issuingOrgSelected,
  appTypesSelected,
  careerStageSelected,
  fundingOpportunitySelected,
  query,
  mentoredSelected,
  pdpiSelected,
  refLetterSelected,
  fundingSubCategory_RTCD,
  fundingSubCategory_RD,
  fundingSubCategory_SB,
  startDate,
  endDate,
  researchInitiativeSelected
}) {
  const [typePills, setTypePills] = useState("");
  const [includeNosis, setIncludeNosis] = useState(false);

  useEffect(() => {
    let temp_type = [];
    if (type.includes("active")) {
      temp_type.push("Active Opportunities");
    }
    if (type.includes("expired")) {
      temp_type.push("Expired Opportunities");
    }
    if (type.includes("notices")) {
      temp_type.push("Active Notices");
    }
    if (type.includes("expirednosis") && tabType === "notices") {
      temp_type.push("Expired Notices");
    }

    if (
      (type.includes("activenosis") || type.includes("expirednosis")) &&
      type.join(",") !== "notices,expirednosis" &&
      type.join(",") !== "expirednosis,notices"
    ) {
      setIncludeNosis(true);
    } else {
      setIncludeNosis(false);
    }

    setTypePills(temp_type.join(", "));
  }, [type, tabType]);

  return (
    <div className={background + " " + (isSmallScreen ? "px-3 pt-2" : "")}>
      {fundingCategory.length > 0 ? (
        <div className="search-pill">
          {fundingCategory.map((org, index) => {
            return (
              <span key={"ab-" + index + "c-label"}>
                {org.label}
                {fundingCategory.length > 1
                  ? index !== fundingCategory.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {fundingSubCategory_RTCD.length > 0 ? (
        <div className="search-pill">
          {fundingSubCategory_RTCD.map((org, index) => {
            return (
              <span key={"cd-" + index + "c-label"}>
                {org.label}
                {fundingSubCategory_RTCD.length > 1
                  ? index !== fundingSubCategory_RTCD.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {fundingSubCategory_RD.length > 0 ? (
        <div className="search-pill">
          {fundingSubCategory_RD.map((org, index) => {
            return (
              <span key={"ef-" + index + "c-label"}>
                {org.label}
                {fundingSubCategory_RD.length > 1
                  ? index !== fundingSubCategory_RD.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {fundingSubCategory_SB.length > 0 ? (
        <div className="search-pill">
          {fundingSubCategory_SB.map((org, index) => {
            return (
              <span key={"gh-" + index + "c-label"}>
                {org.label}
                {fundingSubCategory_SB.length > 1
                  ? index !== fundingSubCategory_SB.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      <div className="search-pill">{typePills}</div>

      {includeNosis && <div className="search-pill">Include NOSIs</div>}

      {noticeType.length > 0 ? (
        <div className="search-pill">
          {noticeType.map((org, index) => {
            return (
              <span key={"ij-" + index + "c-label"}>
                {org.label}
                {noticeType.length > 1
                  ? index !== noticeType.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {activity_code !== "" && activity_code !== "all" ? (
        <div className="search-pill">
          {Array.isArray(activity_code)
            ? activity_code.join(", ")
            : activity_code.replaceAll(",", ", ")}
        </div>
      ) : (
        ""
      )}

      {clinicalTrialsAllowedSelected !== "" ? (
        <div className="search-pill">
          {clinicalTrialsAllowedSelected === "allowed"
            ? "Clinical Trials Allowed"
            : "Clinical Trials Not Allowed"}
        </div>
      ) : (
        ""
      )}

      {fundingInstrumentSelected.length > 0 ? (
        <div className="search-pill">
          {fundingInstrumentSelected.map((org, index) => {
            return (
              <span key={"kl-" + index + "c-label"}>
                {org.label}
                {fundingInstrumentSelected.length > 1
                  ? index !== fundingInstrumentSelected.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}


      {fundingOrganizations.length > 0 ? (
        <div className="search-pill">
          {fundingOrganizations.map((org, index) => {
            return (
              <span key={"dd" + index + "filter"}>
                {org.abv}
                {fundingOrganizations.length > 1
                  ? index !== fundingOrganizations.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {issuingOrgSelected ? (
        <div className="search-pill">Issuing Organizations Only </div>
      ) : (
        ""
      )}


      {appTypesSelected.length > 0 ? (
        <div className="search-pill">
          Application Types Allowed:{" "}
          {appTypesSelected.map((org, index) => {
            return (
              <span key={"mn-" + index + "c-label"}>
                {org.label}
                {appTypesSelected.length > 1
                  ? index !== appTypesSelected.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}

      {researchInitiativeSelected.length > 0 ? (
        <div className="search-pill">
          Research Initiative:{" "}
          {researchInitiativeSelected.map((org, index) => {
            return (
              <span key={"mn-" + index + "r-label"}>
                {org.label}
                {researchInitiativeSelected.length > 1
                  ? index !== researchInitiativeSelected.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}


      {careerStageSelected.length > 0 ? (
        <div className="search-pill">
          {careerStageSelected.map((org, index) => {
            return (
              <span key={"op-" + index + "c-label"}>
                {org.label}
                {careerStageSelected.length > 1
                  ? index !== careerStageSelected.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}
      

      {fundingOpportunitySelected.length > 0 ? (
        <div className="search-pill">
          {fundingOpportunitySelected.map((org, index) => {
            return (
              <span key={"qr-" + index + "c-label"}>
                {org.label}
                {fundingOpportunitySelected.length > 1
                  ? index !== fundingOpportunitySelected.length - 1
                    ? ", "
                    : ""
                  : ""}
              </span>
            );
          })}
        </div>
      ) : (
        ""
      )}
      
      {query !== "" ? <div className="search-pill"> {query} </div> : ""}

      {mentoredSelected !== "" ? (
        mentoredSelected === "Y" ? (
          <div className="search-pill">Mentored </div>
        ) : (
          <div className="search-pill">Not Mentored </div>
        )
      ) : (
        ""
      )}

      {pdpiSelected !== "" ? (
        pdpiSelected === "Y" ? (
          <div className="search-pill">PD/PI Citizenship Required </div>
        ) : (
          <div className="search-pill">PD/PI Citizenship Not Required </div>
        )
      ) : (
        ""
      )}

      {refLetterSelected !== "" ? (
        refLetterSelected === "Y" ? (
          <div className="search-pill">Reference Letters Required </div>
        ) : (
          <div className="search-pill">Reference Letters Not Required </div>
        )
      ) : (
        ""
      )}

      {!isSameDay(startDate, new Date(1991, 0, 1)) ||
      !isSameDay(endDate, new Date()) ? (
        <div className="search-pill">{`${format(
          startDate,
          "MMM d, yyyy"
        )} - ${format(endDate, "MMM d, yyyy")}`}</div>
      ) : (
        ""
      )}
    </div>
  );
}

export default CurrentFiltersPills;
